export enum ViewerPublicApiError {
  MissingViewedMember = 'Error: missing viewed member. Please check if method is called in members area context',
  MissingContext = 'Error: missing context. Please check if method is called in members area context',
}
